import { 
  SET_PROFILE_DATA, 
  UPDATE_PROFILE_DATA, 
  CLEAR_PROFILE_DATA,
  SET_USER_SETTINGS,
  UPDATE_USER_SETTINGS,
  UPDATE_USER_SETTINGS_START,
  UPDATE_USER_SETTINGS_SUCCESS,
  UPDATE_USER_SETTINGS_FAILURE,
  UPDATE_BANK_ACCOUNT,
  SET_BROKER_SETTINGS,
  SET_MASTER_SETTINGS,
  SET_EXCHANGE_SESSIONS
} from '../actions/profile';

const initialState = {
  userData: null,
  isLoaded: false,
  error: null,
  isUpdating: false,
  updateError: null,
  userSettings: {
    client_id: null,
    default_chart: "tdv",
    default_dashboard_chart: "nifty",
    execution_type: "REGULAR",
    marketwatch_settings: {
      font_size: "medium",
      price_change: "percentage",
      selected_marketwatch: 1,
      sort_key: "alphabet",
      sort_marketwatch: false
    },
    notification_sound: true,
    order_type: "LIMIT",
    product_type: "CNC/NRML",
    show_order_update: true,
    subscription_type: "compact",
    theme: "light",
    validity: "DAY"
  },
  brokerSettings: {},
  masterSettings: {},
  exchangeSessions: []
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFILE_DATA:
      return {
        ...state,
        userData: action.payload,
        isLoaded: true,
        error: null
      };
    
    case UPDATE_PROFILE_DATA:
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload
        },
        error: null
      };
    
    case CLEAR_PROFILE_DATA:
      return initialState;
    
    case SET_USER_SETTINGS:
      return {
        ...state,
        userSettings: {
          ...initialState.userSettings,
          ...action.payload
        }
      };

    case UPDATE_USER_SETTINGS:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          ...action.payload
        }
      };
      
    case UPDATE_USER_SETTINGS_START:
      return {
        ...state,
        isUpdating: true,
        updateError: null
      };
      
    case UPDATE_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updateError: null
      };
      
    case UPDATE_USER_SETTINGS_FAILURE:
      return {
        ...state,
        isUpdating: false,
        updateError: action.payload
      };
    case UPDATE_BANK_ACCOUNT:
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload
        }
      };
    case SET_BROKER_SETTINGS:
      return {
        ...state,
        brokerSettings: action.payload
      };
    case SET_MASTER_SETTINGS:
      return {
        ...state,
        masterSettings: action.payload
      };
    case SET_EXCHANGE_SESSIONS:
      return {
        ...state,
        exchangeSessions: action.payload
      };
    default:
      return state;
  }
};

export default profileReducer; 